import { useEffect } from "react";

export const SITE_URL = "https://rokmotors.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Lightweight SEO manager for the SPA. Updates title, meta description,
// canonical URL and Open Graph / Twitter tags on route change.
export function useSeo({ title, description, path, image, keywords } = {}) {
  useEffect(() => {
    const fullTitle = title || document.title;
    const canonical = `${SITE_URL}${path || window.location.pathname}`.replace(/\/$/, "") || SITE_URL;
    const ogImage = image || DEFAULT_OG_IMAGE;

    if (title) document.title = fullTitle;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", canonical);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:type", "website");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);
  }, [title, description, path, image, keywords]);
}
